import {
  MONTH_MAP,
  mapBEKeyDateTypeToFEKeyDate,
  MONTH_NUM_MAP,
  getClientDisplayNameById,
  getSelectedClientAppliesToType,
  getDefaultInflationRate,
  convertYearToAgeByClient,
  getSelectedClient,
  getCurrentYear,
} from "../../common/shared";
import { SERVER_URL } from "../../config";
import { appendTimestamp } from "../../common/shared";
import axios from "axios";
import { mapFromBEData as AllocationMapFromBEData } from "../admin/allocations";

export const TAX_CATEGORY_DEFERRED = "TAX_DEFERRED";
export const TAX_CATEGORY_TAXABLE = "TAXABLE";
export const TAX_CATEGORY_EXEMPT = "TAX_EXEMPT";

export const ACCOUNTTYPE_401k = "TAX_DEFERRED_401K";
export const ACCOUNTTYPE_403B = "TAX_DEFERRED_403B";
export const ACCOUNTTYPE_BENEFICIARY = "BENEFICIARY_IRA";
export const ACCOUNTTYPE_INDIVIDUAL_401K = "INDIVIDUAL_401K";
export const ACCOUNTTYPE_DEFINED_CONTRIBUTION = "DEFINED_CONTRIBUTION_PLAN";
export const ACCOUNTTYPE_DEFINED_BENEFIT = "DEFINED_BENEFIT_PLAN";
export const ACCOUNTTYPE_FIXED_ANNUITY = "FIXED_ANNUITY";
export const ACCOUNTTYPE_PROFIT_SHARING_PLAN = "PROFIT_SHARING_PLAN";
export const ACCOUNTTYPE_ROLLOVER_IRA = "ROLLOVER_IRA";
export const ACCOUNTTYPE_SEP_IRA = "SEP_IRA";
export const ACCOUNTTYPE_SIMPLE_IRA = "SIMPLE_IRA";
export const ACCOUNTTYPE_TRADITIONAL_IRA = "TRADITIONAL_IRA";
export const ACCOUNTTYPE_VARIABLE_ANNUITY = "VARIABLE_ANNUITY";
export const ACCOUNTTYPE_ESOP = "ESOP";
export const ACCOUNTTYPE_OTHER = "TAXABLE_OTHER";

export const ACCOUNTTYPE_BROKERAGE = "BROKERAGE";
export const ACCOUNTTYPE_INDIVIDUAL = "INDIVIDUAL";
export const ACCOUNTTYPE_TRUST = "TRUST";
export const ACCOUNTTYPE_JOINT_ACCOUNT = "JOINT";
export const ACCOUNTTYPE_TENANTS_BY_ENTIRETY = "TENANTS_BY_ENTIRETY";
export const ACCOUNTYPE_TENANTS_IN_COMMON = "TENANTS_IN_COMMON";
export const ACCOUNTTYPE_CUSTODIAL_ACCOUNT = "CUSTODIAL";
export const ACCOUNTTYPE_CORPORATE_ACCOUNT = "CORPORATE";
export const ACCOUNTTYPE_PARTNERSHIP = "PARTNERSHIP";
export const ACCOUNTTYPE_SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP";

export const ACCOUNTTYPE_ROTH_IRA = "ROTH_IRA";
export const ACCOUNTTYPE_ROTH_401K = "ROTH_401K";
export const ACCOUNTTYPE_529_PLAN = "TAX_EXEMPT_529_PLAN";
export const ACCOUNTTYPE_COVERDELL_ESA = "COVERDELL_ESA";
export const ACCOUNTTYPE_CASH_ACCOUNT = "CASH";

export const CUSTODIAN_TDAMERITRADE = "TD_AMERITRADE";
export const CUSTODIAN_CHARLESSCHWABB = "CHARLES_SCHWAB";
export const CUSTODIAN_PERSHING = "PERSHING";
export const CUSTODIAN_FIDELITY = "FIDELITY";
export const CUSTODIAN_OTHER = "OTHER";

export const MANAGED_MANAGED = "MANAGED";
export const MANAGED_MANAGED_FULL_CUSTODY = "FULL_CUSTODY";
export const MANAGED_NOT_MANAGED = "NOT_MANAGED";

export const AMOUNT_TYPES = {
  AMOUNT: { key: "AMOUNT", name: "Dollar Amount" },
  PERCENT: { key: "PERCENT", name: "% of Income" },
};

export const RMD_ACCOUNT_TYPES = [
  ACCOUNTTYPE_401k,
  ACCOUNTTYPE_403B,
  ACCOUNTTYPE_BENEFICIARY,
  ACCOUNTTYPE_DEFINED_BENEFIT,
  ACCOUNTTYPE_DEFINED_CONTRIBUTION,
  ACCOUNTTYPE_FIXED_ANNUITY,
  ACCOUNTTYPE_INDIVIDUAL_401K,
  ACCOUNTTYPE_PROFIT_SHARING_PLAN,
  ACCOUNTTYPE_ROLLOVER_IRA,
  ACCOUNTTYPE_SEP_IRA,
  ACCOUNTTYPE_SIMPLE_IRA,
  ACCOUNTTYPE_TRADITIONAL_IRA,
  ACCOUNTTYPE_VARIABLE_ANNUITY,
  ACCOUNTTYPE_ESOP,
];

export const mapBEAccountToFEAccount = (account, index) => {
  const getFrequencyLabel = (frequencyType) => {
    if (frequencyType === "YEARLY") return "Yearly";
    if (frequencyType === "MONTHLY") return "Monthly";
    return "Weekly";
  };

  return {
    id: account.id,
    isRothConversionAccount: account.isRothConversionAccount,
    name: account.name,
    scopeType: account.scopeType,
    taxCategory: { key: account.taxType, name: "Taxable" },
    accountType: { key: account.accountType, name: "401K" },
    isReinvest: account.isReinvest !== null ? account.isReinvest : false,
    owner: {
      id: account.appliesTo.appliesToId ? account.appliesTo.appliesToId : 0,
      name: getClientDisplayNameById(account.appliesTo.appliesToId),
    },
    currentValue: account.currentValue,
    costBasis: account.costBasis,
    valueAsOfDate: account.valueAsOf,
    custodian: { key: account.accountCustodian, name: "401K" },
    custodianName: account.accountCustodianOtherValue,
    accountNumber: account.custodianAccountNum,
    webAccess: account.custodianURL,
    managed: { key: account.managedStatus, name: "MANAGED" },
    managedBy: account.managedBy,
    clientUserName: account.managedUserName,
    clientPassword: account.managedPassword,
    usedInPlans: [],
    preRetirementAllocation: account.preAllocation / 100,
    postRetirementAllocation: account.postAllocation / 100,
    isEdited: false,
    inEdit: false,
    editIndex: index,
    isCopy: false,
    isRMDEnable: account.isRMDEnable,
    sortOrder: account.sortOrder,
    isExpanded: false,
    isEarlyDistribution: account.earlyDistribution,
    earlyDistributionPenaltyList: account.earlyDistributionPenaltyList,
    allocation:
      account.allocationModelView == null
        ? null
        : AllocationMapFromBEData(account.allocationModelView),
    accountAllocation: account.allocationModelView !== null,
    notes: account.notes,
    contributions: account.contributionList.map(
      (element, contributionIndex) => {
        return {
          id: element.id,
          editIndex: contributionIndex,
          frequencyType: {
            key: element.amount.frequency,
            name: getFrequencyLabel(element.amount.frequency),
          },
          amount: element.amount.amount,
          totalYearsInflatedAmount: element.amount.totalYearsInflatedAmount,
          employerMatch: element.employerMatch,
          contributionType: AMOUNT_TYPES[element.amount.amountType],
          percentage: element.amount.percentage / 100,
          matchType: { key: element.matchType, name: "Amount" },
          matchAmount:
            element.matchType === "AMOUNT"
              ? element.matchAmount
              : element.matchAmount / 100,
          inflationRate: element.amount.inflationRate,
          futureValue: element.amount.futureValue,
          matchCap: element.matchCap,
          description: "description",
          endDateValid: true,
          startYear: element.date.startYear,
          startMonth: MONTH_MAP[element.date.startMonth - 1],
          startAge: convertYearToAgeByClient(
            element.date.startYear,
            getSelectedClient({ id: account.appliesTo.appliesToId }),
            MONTH_MAP[element.date.startMonth - 1]
          ),
          endYear: element.date.endYear,
          endMonth: MONTH_MAP[element.date.endMonth - 1],
          endAge: convertYearToAgeByClient(
            element.date.endYear,
            getSelectedClient({ id: account.appliesTo.appliesToId }),
            MONTH_MAP[element.date.endMonth - 1]
          ),
          start: new Date(
            element.date.startYear,
            element.date.startMonth - 1,
            element.date.startMonth - 1 === 11 ? 31 : 1
          ),
          end: new Date(
            element.date.endYear,
            element.date.endMonth - 1,
            element.date.endMonth - 1 === 11 ? 31 : 1
          ),
          interval: account.interval,
        };
      }
    ),
    withdrawals: account.withdrawalList.map((element) => {
      return {
        id: element.id,
        frequencyType: {
          key: element.amount.frequency,
          name: getFrequencyLabel(element.amount.frequency),
        },
        amount: element.amount.amount,
        employerMatch: element.employerMatch,
        contributionType: AMOUNT_TYPES[element.amount.amountType],
        percentage: element.amount.percentage / 100,
        matchType: { key: element.matchType, name: "Amount" },
        matchAmount:
          element.matchType === "AMOUNT"
            ? element.matchAmount
            : element.matchAmount / 100,
        inflation: element.amount.inflationRate,
        futureValue: element.amount.futureValue,
        matchCap: element.matchCap,
        description: "description",
        startDate: {
          keyDateType: mapBEKeyDateTypeToFEKeyDate(element.date.startDateType),
          month: MONTH_MAP[element.date.startMonth],
          year: element.date.startYear,
          age: 0,
          relativeAge: element.date.relativeStartDateNum,
        },
        endDate: {
          keyDateType: mapBEKeyDateTypeToFEKeyDate(element.date.endDateType),
          month: MONTH_MAP[element.date.endMonth],
          year: element.date.endYear,
          age: 0,
          relativeAge: element.date.relativeEndDateNum,
        },
        interval: account.interval,
        start: new Date(
          element.date.startYear,
          element.date.startMonth - 1,
          element.date.startMonth - 1 === 11 ? 31 : 1
        ),
        end: new Date(
          element.date.endYear,
          element.date.endMonth - 1,
          element.date.endMonth - 1 === 11 ? 31 : 1
        ),
      };
    }),
    transfers: account.transferViewList.map((transfer) => {
      return {
        id: transfer.id,
        name: transfer.transferAccountName,
        transferAccount: {
          id: transfer.transferAccountId,
          name: transfer.transferAccountName,
        },
        transferOptions: {
          key: transfer.transferType,
          name: "Transfer In",
        },
        transferType: {
          key: transfer.transferAmountType,
          name: "Amount",
        },
        taxCategory: { key: transfer.taxType, name: "Taxable" },
        accountType: { key: transfer.accountType, name: "401K" },
        frequencyType: { key: transfer.amount.frequency, name: "Yearly" },
        transferAmount: transfer.amount.amount,
        inflation: transfer.amount.inflationRate,
        taxable: transfer.taxable,
        futureValue: transfer.amount.futureValue,
        description: "description",
        startDate: {
          keyDateType: mapBEKeyDateTypeToFEKeyDate(transfer.date.startDateType),
          month: MONTH_MAP[transfer.date.startMonth],
          year: transfer.date.startYear,
          age: 0,
          relativeAge: transfer.relativeStartDateNum,
        },
        endDate: {
          keyDateType: mapBEKeyDateTypeToFEKeyDate(transfer.date.endDateType),
          month: MONTH_MAP[transfer.date.endMonth],
          year: transfer.date.endYear,
          age: 0,
          relativeAge: transfer.date.relativeEndDateNum,
        },
      };
    }),
  };
};

export const getTaxType = (key) => {
  return [
    {
      key: ACCOUNTTYPE_401k,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_403B,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_BENEFICIARY,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_INDIVIDUAL_401K,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_DEFINED_CONTRIBUTION,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_DEFINED_BENEFIT,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_FIXED_ANNUITY,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_PROFIT_SHARING_PLAN,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_ROLLOVER_IRA,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_SEP_IRA,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_SIMPLE_IRA,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_TRADITIONAL_IRA,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_VARIABLE_ANNUITY,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_ESOP,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_OTHER,
      category: TAX_CATEGORY_DEFERRED,
    },
    {
      key: ACCOUNTTYPE_BROKERAGE,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_INDIVIDUAL,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_TRUST,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_JOINT_ACCOUNT,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_TENANTS_BY_ENTIRETY,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTYPE_TENANTS_IN_COMMON,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_CUSTODIAL_ACCOUNT,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_CORPORATE_ACCOUNT,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_PARTNERSHIP,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_SOLE_PROPRIETORSHIP,
      category: TAX_CATEGORY_TAXABLE,
    },
    {
      key: ACCOUNTTYPE_ROTH_IRA,
      category: TAX_CATEGORY_EXEMPT,
    },
    {
      key: ACCOUNTTYPE_ROTH_401K,
      category: TAX_CATEGORY_EXEMPT,
    },
    {
      key: ACCOUNTTYPE_529_PLAN,
      category: TAX_CATEGORY_EXEMPT,
    },
    {
      key: ACCOUNTTYPE_COVERDELL_ESA,
      category: TAX_CATEGORY_EXEMPT,
    },
    {
      key: ACCOUNTTYPE_CASH_ACCOUNT,
      category: TAX_CATEGORY_EXEMPT,
    },
  ].filter((a) => a.key === key);
};

const mapAccountTypeToTaxCategory = (accountType) => {
  return getTaxType(accountType.key)[0].category;
};

export const mapFEAccountToBEAccount = (account, index) => {
  return {
    id: account.id,
    name: account.name,
    scopeType: account.scopeType,
    taxType: mapAccountTypeToTaxCategory(account.accountType),
    accountType: account.accountType.key,
    appliesTo: {
      appliesToId: account.owner.id,
      appliesToType: getSelectedClientAppliesToType(account.owner),
    },
    isReinvest: account.isReinvest ? account.isReinvest : false,
    currentValue: account.currentValue,
    costBasis: account.currentValue,
    valueAsOf: new Date(account.valueAsOfDate),
    accountCustodian:
      account.custodian === "" ? CUSTODIAN_TDAMERITRADE : account.custodian.key,
    accountCustodianOtherValue: account.custodianName,
    custodianAccountNum: account.accountNumber,
    custodianURL: account.webAccess,
    managedStatus:
      account.managed === "" ? MANAGED_MANAGED : account.managed.key,
    managedBy: account.managedBy,
    managedUserName: account.clientUserName,
    managedPassword: account.managedPassword,
    allocationModelView: account.allocation,
    preAllocation: account.preRetirementAllocation * 100.0,
    postAllocation: account.postRetirementAllocation * 100.0,
    sortOrder: account.sortOrder,
    isRMDEnable: account.isRMDEnable,
    isEdited: account.isEdited,
    isCopied: account.isCopy,
    accountAllocation: account.allocation !== null,
    notes: account.notes,
    contributionList: account.contributions.map((element) => {
      return {
        id: element.id,
        description: element.name,
        isEdited: element.isEdited,
        amount: {
          frequency: element.frequencyType.key,
          amountType: element.contributionType.key,
          percentage: element.percentage * 100,
          amount: element.amount,
          inflationRate: element.inflationRate * 100,
          futureValue: element.futureValue,
        },
        date: {
          startDateType: "REGULAR_DATE",
          endDateType: "REGULAR_DATE",
          startYear: element.startYear,
          relativeStartDateNum: 0,
          endYear: element.endYear,
          relativeEndDateNum: 0,
          startMonth: MONTH_NUM_MAP[element.startMonth],
          endMonth: MONTH_NUM_MAP[element.endMonth],
        },
        employerMatch: 0,
        matchAmount: 0,
        matchCap: 0,
        matchType: "AMOUNT",
      };
    }),
    withdrawalList: account.withdrawals.map((element) => {
      return {
        id: element.id,
        amount: {
          frequency: element.frequencyType.key,
          amount: element.amount,
          inflationRate: element.inflation * 100,
          futureValue: element.futureValue,
        },
        date: {
          startDateType: "REGULAR_DATE",
          endDateType: "REGULAR_DATE",
          startYear: element.start.getFullYear(),
          relativeStartDateNum: 0,
          endYear: element.end.getFullYear(),
          relativeEndDateNum: 0,
          startMonth: element.start.getMonth() + 1,
          endMonth: element.end.getMonth() + 1,
        },
        employerMatch: 0,
        matchAmount: 0,
        matchCap: 0,
        matchType: "AMOUNT",
      };
    }),
    transferViewList: account.transfers.map((element) => {
      return {
        id: element.id,
        transferType: element.transferOptions.key,
        transferAmountType: element.transferType.key,
        taxType: element.taxCategory.key,
        accountType: element.accountType.key,
        taxable: element.taxable,
        transferAccountName: element.name,
        transferAccountId: element.transferAccount.id,
        date: {
          startDateType: "REGULAR_DATE",
          endDateType: "REGULAR_DATE",
          startYear: element.startDate.year,
          relativeStartDateNum: element.startDate.relativeAge,
          endYear: element.endDate.year,
          relativeEndDateNum: element.endDate.relativeAge,
          startMonth: MONTH_NUM_MAP[element.startDate.month],
          endMonth: MONTH_NUM_MAP[element.endDate.month],
        },
        amount: {
          frequency: element.frequencyType.key,
          amount: element.transferAmount,
          inflationRate: element.inflation * 100,
          futureValue: element.futureValue,
        },
      };
    }),
  };
};

export const createAccountLedgerPrototype = (props, t) => {
  const currentYear = new Date().getFullYear();

  return {
    id: null,
    frequencyType: {
      key: "YEARLY",
      name: t("ClientDetails.Profile.Income.Frequency.yearly"),
    },
    amount: 0,
    employerMatch: false,
    matchType: {
      key: "PERCENT",
      name: t("ClientDetails.Profile.Accounts.LedgerEntry.MatchType.percent"),
    },
    matchAmount: 0,
    inflation: getDefaultInflationRate(
      props.defaultInflation.toJS(),
      "contribution"
    ),
    futureValue: false,
    matchCap: 0,
    startYear: currentYear,
    startAge: 0,
    endYear: currentYear,
    endAge: 0,
    startDate: {
      keyDateType: mapBEKeyDateTypeToFEKeyDate("REGULAR_DATE"),
      month: MONTH_MAP[0],
      year: currentYear,
      age: 0,
      relativeAge: 0,
    },
    endDate: {
      keyDateType: mapBEKeyDateTypeToFEKeyDate("REGULAR_DATE"),
      month: MONTH_MAP[11],
      year: currentYear,
      age: 0,
      relativeAge: 0,
    },
    interval: 0,
  };
};

export const createAccountTransferPrototype = (t, accountDDL) => {
  return {
    id: null,
    name: "",
    transferAccount: accountDDL[0],
    transferType: {
      key: "PERCENT",
      name: t("ClientDetails.Profile.Accounts.LedgerEntry.MatchType.percent"),
    },
    transferOptions: {
      key: "TRANSFER_IN",
      name: t(
        "ClientDetails.Profile.Accounts.Transfer.TransferOptions.transfer_in"
      ),
    },
    taxCategory: {
      key: TAX_CATEGORY_TAXABLE,
      name: t("ClientDetails.Profile.Accounts.TaxCategory.taxable"),
    },
    accountType: {
      key: ACCOUNTTYPE_BROKERAGE,
      name: t("ClientDetails.Profile.Accounts.AccountType.brokerage"),
      category: TAX_CATEGORY_TAXABLE,
    },
    frequencyType: {
      key: "YEARLY",
      name: t("ClientDetails.Profile.Income.Frequency.yearly"),
    },
    transferAmount: 0,
    inflation: 0,
    taxable: false,
    futureValue: false,
    startDate: {
      keyDateType: mapBEKeyDateTypeToFEKeyDate("REGULAR_DATE"),
      month: MONTH_MAP[0],
      year: getCurrentYear(),
      age: 0,
      relativeAge: 0,
    },
    endDate: {
      keyDateType: mapBEKeyDateTypeToFEKeyDate("REGULAR_DATE"),
      month: MONTH_MAP[11],
      year: getCurrentYear(),
      age: 0,
      relativeAge: 0,
    },
  };
};

export const getClientAccounts = (advisorId, clientId) => {
  console.log("Advisor Account - getClientAccounts");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/accounts`
    );

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload.map(mapBEAccountToFEAccount));
    });
  });
};

const createAccount = (advisorId, clientId, account) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/account`
    );

    axios
      .post(targetUrl, mapFEAccountToBEAccount(account))
      .then((response) => resolve(response.data.payload));
  });
};

const updateAccount = (advisorId, clientId, account) => {
  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/account/${account.id}`
    );

    axios
      .put(targetUrl, mapFEAccountToBEAccount(account))
      .then((response) => resolve(response.data.payload));
  });
};

export const saveAccount = (advisorId, clientId, account) => {
  console.log("Advisor Accounts - saveAccount");

  if (account.id === null) return createAccount(advisorId, clientId, account);
  return updateAccount(advisorId, clientId, account);
};

export const deleteAccount = (advisorId, clientId, accountId) => {
  console.log("Advisor Accounts - deleteAccount");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/account/${accountId}`
    );

    axios.delete(targetUrl).then(resolve({}));
  });
};

export const batchUpdateAdvisorAccounts = (
  advisorId,
  clientId,
  accountList
) => {
  console.log("Advisor Account API - batchUpdateAdvisorAccounts");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/accounts`;
    const payload = accountList.map(mapFEAccountToBEAccount);

    axios.post(targetUrl, payload).then((response) => {
      const accountList = response.data.payload.map(mapBEAccountToFEAccount);
      resolve(accountList);
    });
  });
};

export const batchDeleteAdvisorAccounts = (
  advisorId,
  clientId,
  accountIdList
) => {
  console.log("Advisor Account API - batchDeleteAdvisorAccounts");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/advisor/${advisorId}/client/${clientId}/account/batch-delete`;

    axios.post(targetUrl, accountIdList).then(() => resolve({}));
  });
};
